<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <input
            @change="handleFileChange"
            type="file"
            id="fileInput"
            style="display: none"
            webkitdirectory
            directory
            multiple
          />
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-12">
          <H1>imoprtando xml Compra</H1>
          <button class="btn btn-secondary" @click="importa_pedido_xml()">
            Upload
          </button>
        </div>
      </div>
      <!-- inicio -->
      <div class="row" v-if="upload_bool">
        <div class="col-md-12">
          <b-table
            bordered
            hover
            :items="files_array"
            id="doc-itens"
            :fields="fields"
          >
            <template #cell(check)="row">
              <div>
                <b-form-checkbox
                  v-model="row.item.check"
                  @change="seleciona_check(row.item, row.item.check, row.index)"
                >
                </b-form-checkbox>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row mt-4 d-flex justify-content-center align-items-center">
        <div class="col-md-12 text-center" v-if="upload_bool">
          <button
            class="btn btn-secondary"
            @click.prevent="envia_pre_nfe_selecionadados()"
          >
            Enviar
          </button>
          <button class="btn btn-success ml-2" @click.prevent="ver()">
            Ver
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <Label>Seleciona o Local de Estoque</Label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="select_local_estoque_id"
            @change="seleciona_local_estoque($event)"
          >
            <option value="-1">selecione o Local de Estoque</option>
            <option
              v-for="(item, index) in locais_estoques"
              :key="index"
              :value="item.id"
            >
              {{ item.descricao }}
            </option>
          </select>
        </div>
      </div>
      <div class="row" v-if="prods_post.length > 0">
        <dv class="col-md-12">
          <b-modal
            :visible="show_modal_produtos"
            size="xl"
            title="Produtos"
            hide-footer
            @hidden="back_modal_produtos()"
          >
            <!-- prods_post -->
            <b-table
              bordered
              hover
              :items="prods_post"
              id="doc-itens"
              :fields="fields_produtos"
            >
              <template #cell(check)="row">
                <div>
                  <b-form-checkbox
                    v-model="row.item.check"
                    @change="
                      seleciona_check_produto(
                        row.item,
                        row.item.check,
                        row.index
                      )
                    "
                  >
                  </b-form-checkbox>
                </div>
              </template>
              <template #cell(produto_sit)="row">
                <div>
                  <span
                    :class="
                      row.item.produto_sit == 1
                        ? 'badge badge-success'
                        : 'badge badge-danger'
                    "
                    >{{
                      row.item.produto_sit == 1 ? "Existe" : "Não Existe"
                    }}</span
                  >
                </div>
              </template>
              <template #cell(loc_estoque)="row">
                <div>
                  <select
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="row.item.loc_estoque"
                    @change="seleciona_local_estoque($event)"
                  >
                    <option value="-1">selecione o Local de Estoque</option>
                    <option
                      v-for="(item, index) in locais_estoques"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.descricao }}
                    </option>
                  </select>
                </div>
              </template>
              <template #cell(acoes)="row">
                <div>
                  <b-dropdown
                    v-bind:id="'dropdown-' + row.item.id"
                    class="m-md-2"
                  >
                    <template #button-content>
                      <i data-v-6289eca4="" class="bx ri-menu-line"></i>
                    </template>
                    <b-dropdown-item @click="setGeraEstoque(row.item)"
                      ><i class="bx ri-eraser-fill"></i> Gerar
                      Estoque</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click="set_Adc_GeraEstoque(row.item)"
                      v-if="row.item.produto_sit != 1"
                      ><i class="bx ri-edit-2-line"></i>
                      Adicionar</b-dropdown-item
                    >
                    <b-dropdown-item @click="setAlterar(row.item)"
                      ><i class="bx ri-eraser-fill"></i>
                      Alterar</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </template>
            </b-table>
            <div class="row" v-if="objeto_atual_prod">
              <div class="col-md-12">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle.produto-dados-gerais
                    variant="light"
                    >Dados Produto Selecionado</b-button
                  >
                </b-card-header>
                <b-collapse
                  id="produto-dados-gerais"
                  visible
                  accordion="produto-accordion"
                  role="tabpanel"
                >
                  <div class="row">
                    <div class="col-md-4">
                      <Label>Produto Nome</Label>
                      <input v-model="objeto_atual_prod.produto_nome" type="text" class="form-control text-left" />
                    </div>
                    <div class="col-md-4">
                      <Label>NCM</Label>
                      <input v-model="objeto_atual_prod.NCM" type="text" class="form-control text-left" />
                    </div>
                    <div class="col-md-4">
                      <Label>Quantidade</Label>
                      <input v-model="objeto_atual_prod.qtd" type="text" class="form-control text-left" />
                    </div>
                  </div>
                  <div class="row d-flex justify-content-center align-items-center mt-4">
                     <div class="col-md-12 text-center">
                         <button class="btn btn-success" @click="confirmar_alt_prod()">Confirmar Alteração</button>
                     </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </b-modal>
        </dv>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from "../../../../helpers/easyindustriaapi/config";
export default {
  props: {
    listProdutos: { type: Array },
    vet_loc_estoques: { type: Array },
  },
  data() {
    return {
      objeto_atual_prod: null,
      prods_post: [],
      show_modal_produtos: false,
      select_local_estoque_id: null,
      locais_estoques: [],
      vet_produtos: [],
      guarda_xmls: [],
      xml: null,
      upload_bool: false,
      files_array: [],
      files_array2: [],
      array_files_sem_check: [],
      vetor_new_pre_nfe: [],
      fields: [
        {
          label: "Selecione",
          key: "check",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Nome",
          key: "name",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Tamanho",
          key: "size",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Data",
          key: "lastModifiedDate",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      fields_produtos: [
        {
          label: "Selecione",
          key: "check",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Nome",
          key: "produto_nome",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Situação",
          key: "produto_sit",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Loc Estoque",
          key: "loc_estoque",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Acoes",
          key: "acoes",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      xmlContents: [],
    };
  },
  created() {
    this.vet_produtos = this.listProdutos;
    this.locais_estoques = this.vet_loc_estoques;
  },
  mounted() {},
  methods: {
    confirmar_alt_prod(){
       this.makeToast("success","Confirmado Alteração do Produto")
    },
    handleCheckboxClick(item) {
      if (item.loc_estoque == -1 || item.loc_estoque === undefined) {
        this.$bvToast.toast("Este item não pode ser selecionado", {
          title: "Aviso",
          variant: "warning",
          solid: true,
        });
      }
    },
    setAlterar(objeto) {
      console.log(objeto);
      this.objeto_atual_prod = objeto;
    },
    setGeraEstoque(objeto) {
      console.log(objeto);
      objeto.loc_estoque;
      if (objeto.loc_estoque == -1) {
        this.makeToast("Preencha o Local de Estoque");
        objeto.loc_estoque = null;
      }
      this.doPostAddEstoqueMT({ ...objeto });
    },
    // adiconar e gerar estoque
    set_Adc_GeraEstoque(objeto) {
      console.log(objeto);
      this.doPost({ ...objeto });
    },
    seleciona_check_produto(objeto, status, index) {
      console.log(objeto);

      if (objeto.loc_estoque == -1 || objeto.loc_estoque == undefined) {
        this.makeToast("danger", "Selecione Local de estoque");
        return (objeto.check = null);
      }
      console.log(status);
      console.log(index);
    },
    back_modal_produtos() {
      this.show_modal_produtos = false;
    },
    seleciona_local_estoque(event) {
      console.log(event);
    },
    envia_pre_nfe_selecionadados() {
      console.log("Mostrado veotor ao enviar");
      console.log(this.vetor_new_pre_nfe);
      this.vetor_new_pre_nfe.forEach((f) => {
        this.ler_xml_criar_nfe(f);
      });
    },
    ler_xml_criar_nfe(objeto) {
      console.log(objeto);
      // console.log("estou em ler xml ");
      // console.log(this.fileContent);
      let conteudo = objeto.conteudo;
      if (typeof conteudo === "string") {
        console.log("é uma srting");
      }
      // xml em string //
      let string_xml = conteudo;
      // varivel que vai receber o conteudo convertido de string para xml
      let xmlDocument = new DOMParser().parseFromString(string_xml, "text/xml");
      console.log(xmlDocument);
      let nomes = xmlDocument.querySelectorAll("xProd");
      let cProds = xmlDocument.querySelectorAll("cProd");
      let qComs = xmlDocument.querySelectorAll("qCom");
      let listaNomes = [];

      nomes.forEach((nome, index) => {
        let objeto = {
          xProd: nome.textContent,
          cProd: cProds[index].textContent,
          qCom: qComs[index].textContent,
        };
        listaNomes.push({ ...objeto });
      });
      console.log("Mostrando Lista de Obejto de Itens New");
      console.log(listaNomes);

      // lendo produts detalahda mentente

      let dettElements = xmlDocument.querySelectorAll("det");
      let dets = [];
      dettElements.forEach((emitElement) => {
        let dettObj = {
          xProd: emitElement.querySelector("prod > xProd")?.textContent || "",
          cProd: emitElement.querySelector("prod > cProd")?.textContent || "",
          cEAN: emitElement.querySelector("prod > cEAN")?.textContent || "",
          NCM: emitElement.querySelector("prod > NCM")?.textContent || "",
          CFOP: emitElement.querySelector("prod > CFOP")?.textContent || "",
          uCom: emitElement.querySelector("prod > uCom")?.textContent || "",
          qCom: emitElement.querySelector("prod > qCom")?.textContent || "",
          vUnCom: emitElement.querySelector("prod > vUnCom")?.textContent || "",
          vProd: emitElement.querySelector("prod > vProd")?.textContent || "",
          cEANTrib:
            emitElement.querySelector("prod > cEANTrib")?.textContent || "",
          cBarraTrib:
            emitElement.querySelector("prod > cBarraTrib")?.textContent || "",
          uTrib: emitElement.querySelector("prod > uTrib")?.textContent || "",
          qTrib: emitElement.querySelector("prod > qTrib")?.textContent || "",
          vUnTrib:
            emitElement.querySelector("prod > vUnTrib")?.textContent || "",
          imposto: {
            // ICMS
            icms: {
              orig:
                emitElement.querySelector("imposto > ICMS > ICMSSN102 > orig")
                  ?.textContent || "",
              CSOSN:
                emitElement.querySelector("imposto > ICMS > ICMSSN102 > CSOSN")
                  ?.textContent || "",
            },
            // IPI
            IPI: {
              cEnq:
                emitElement.querySelector("imposto > IPI > cEnq")
                  ?.textContent || "",
              CST:
                emitElement.querySelector("imposto > IPI > IPINT > CST")
                  ?.textContent || "",
            },
            // PIS
            PIS: {
              CST:
                emitElement.querySelector("imposto > PIS > PISNT > CST")
                  ?.textContent || "",
            },
            // COFINS
            COFINS: {
              CST:
                emitElement.querySelector("imposto > COFINS > COFINSNT > CST")
                  ?.textContent || "",
            },
          },
        };

        // Adiciona o objeto emitente ao array
        dets.push(dettObj);
      });
      console.log("mosntrando os dets de Produtos");
      console.log(dets);
      this.vetor_produtos(dets);
      // fim vusca de produos
      let emitElement = xmlDocument.querySelector("emit");
      let emitObj = {
        CNPJ: emitElement.querySelector("CNPJ").textContent,
        xNome: emitElement.querySelector("xNome").textContent,
        xFant: emitElement.querySelector("xFant").textContent,
        enderEmit: {
          xLgr: emitElement.querySelector("enderEmit > xLgr").textContent,
          nro: emitElement.querySelector("enderEmit > nro").textContent,
          xCpl: emitElement.querySelector("enderEmit > xCpl").textContent,
          xBairro: emitElement.querySelector("enderEmit > xBairro").textContent,
          cMun: emitElement.querySelector("enderEmit > cMun").textContent,
          xMun: emitElement.querySelector("enderEmit > xMun").textContent,
          UF: emitElement.querySelector("enderEmit > UF").textContent,
          CEP: emitElement.querySelector("enderEmit > CEP").textContent,
          cPais: emitElement.querySelector("enderEmit > cPais").textContent,
          xPais: emitElement.querySelector("enderEmit > xPais").textContent,
        },
      };
      console.log("mostrando os valores do emitente ");
      console.log(emitObj);
      // ---------------------------------------
      let destElement = xmlDocument.querySelector("dest");
      let destObj = {
        CNPJ: destElement.querySelector("CNPJ").textContent,
        xNome: destElement.querySelector("xNome").textContent,
        // xFant: destElement.querySelector("xFant").textContent,
        enderDest: {
          xLgr: destElement.querySelector("enderDest > xLgr").textContent,
          nro: destElement.querySelector("enderDest > nro").textContent,
          xCpl: destElement.querySelector("enderDest > xCpl").textContent,
          xBairro: destElement.querySelector("enderDest > xBairro").textContent,
          cMun: destElement.querySelector("enderDest > cMun").textContent,
          xMun: destElement.querySelector("enderDest > xMun").textContent,
          UF: destElement.querySelector("enderDest > UF").textContent,
          CEP: destElement.querySelector("enderDest > CEP").textContent,
          cPais: destElement.querySelector("enderDest > cPais").textContent,
          xPais: destElement.querySelector("enderDest > xPais").textContent,
        },
      };
      console.log("mostrando os valores do destinatario");
      console.log(destObj);
      // console.log(destObj.xNome);

      // Processar a tag <ide>
      // let ideElement = xmlDocument.querySelector("ide");
      // let ideObj = {
      //   cNF: ideElement.querySelector("cNF").textContent,
      //   natOp: ideElement.querySelector("natOp").textContent,
      //   dhEmi: ideElement.querySelector("dhEmi").textContent,
      //   dSaida: ideElement.querySelector("dSaida").textContent,
      // };

      // console.log("dados do Ide");
      // console.log(ideObj);

      let objeto_nfe_pre = {};
      // objeto_nfe_pre.DestxNome = destObj.xNome;
      // objeto_nfe_pre.EmitCNPJ = emitObj.CNPJ;
      // objeto_nfe_pre.DestCNPJ = destObj.CNPJ;
      let cont_achou = 0;
      //   listaNomes.forEach((l) => {
      //     let objeto_prod_selecionado = this.produtos_vet.find(
      //       (p) => p.produto_cod_int == l.cProd
      //     );
      //     if (objeto_prod_selecionado == undefined) {
      //       this.makeToast("danger", `produto ${l.xProd} não esta cadastrado`);
      //     } else {
      //       cont_achou++;
      //     }
      //   });
      //pes_cpfcnpj
      //   let selec_cnpj_dest = this.array_pessoas.find(
      //     (p) => p.pes_cpfcnpj == destObj.CNPJ
      //   );

      console.log("mostrando conte achou");
      console.log(cont_achou);
      console.log(this.produtos_vet);
      console.log(this.array_pessoas);

      objeto_nfe_pre.vet2 = listaNomes;
      console.log("mostrando objeto depois do ler xml preNfe");
      console.log(objeto_nfe_pre);

      //   if (objeto_nfe_pre.vet2.length > 0) {
      //     let new_vet = [];
      //     objeto_nfe_pre.vet2.forEach((item) => {
      //       // produto_cod_int
      //       let selecionado_new = this.produtos_vet.find(
      //         (p) => p.produto_cod_int == item.cProd
      //       );
      //       let obj_selecionado = {
      //         descricao: selecionado_new,
      //       };
      //       new_vet.push({ ...obj_selecionado });
      //     });
      //     console.log("mostrando new vet ");
      //     console.log(new_vet);
      //     objeto_nfe_pre.vet = new_vet;
      //     console.log(objeto_nfe_pre.vet);
      //   }
    },
    // verificar se produto do xml ja existe no banco
    verifica_produto_xml(vet_prod_xmls) {
      console.log("estou no veriica XMl");
      this.prods_post = []
      let prods_xml = [...vet_prod_xmls];
      let vet_final = [];

      prods_xml.forEach((item) => {
        let objeto = this.vet_produtos.find((p) => p.codbarras == item.cProd);

        // let objeto2 = this.vet_produtos.find((p) => p.codbarras != item.cProd);

        if (objeto != undefined) {
          objeto.produto_sit = 1;
          // this.prods_post.push({ ...objeto });
          this.prods_post.push({ ...objeto });
        } else {
          let objeto2 = {};
          objeto2.produto_nome = item.xProd;
          objeto2.produto_sit = 0;

          objeto2.codbarras = item.cProd;
          objeto2.produto_descricao = item.xProd;
          objeto2.idtipo = 1;
          objeto2.produto_local_estoque_id = 1;
          objeto2.produto_m_s = "M";
          objeto2.produto_ncm = item.NCM;
          objeto2.produto_cest = "12345";
          objeto2.preco_custo = item.vProd;
          objeto2.preco = item.vProd;
          objeto2.produto_margemlucro = "40.00";
          objeto2.preco_atacado = "1.30";
          objeto2.unidade_id = 5;
          objeto2.um = "UNIDADE";
          objeto2.qtd = item.qCom; // Gerar estoque no local padrão
          objeto2.ativo = -1;
          objeto2.produto_controla_estoque = -1;
          objeto2.produto_balanca = 0;
          objeto2.produto_produzido = 0;
          objeto2.grupo_id = 1;
          objeto2.produto_cean = item.cEANTrib;
          objeto2.produto_orig = item.imposto.icms.orig;
          objeto2.produto_cst = item.imposto.icms.CSOSN;
          objeto2.produto_cstpis = item.imposto.PIS.CST;
          objeto2.produto_cstcofins = item.imposto.COFINS.CST;
          objeto2.produto_cstipi = item.imposto.IPI.CST;
          objeto2.produto_picms = "18";
          objeto2.produto_pbc_icms = "100";
          objeto2.produto_cfop = item.CFOP;
          objeto2.produto_picmsst = "0";
          objeto2.produto_pbc_icmsst = "0";
          objeto2.produto_cenq = "999";
          objeto2.produto_pbc_ipi = "0";
          objeto2.produto_pipi = "0";
          objeto2.produto_pbc_pis = "0";
          objeto2.produto_ppis = "0";
          objeto2.produto_pbc_cofins = "0";
          objeto2.produto_pcofins = "0";
          objeto2.produto_ppisst = "0";
          objeto2.produto_pBC_pisst = "0";
          objeto2.produto_pbc_cofinsst = "0";
          objeto2.produto_pcofinsst = "0";
          objeto2.produto_cste = null;
          objeto2.produto_picmse = "0";
          objeto2.produto_pbc_icmse = "0";
          objeto2.produto_picmsste = "0";
          objeto2.produto_pbc_icmsste = "0";
          objeto2.produto_cenqe = null;
          objeto2.produto_pipie = "0";
          objeto2.produto_pbc_ipie = "0";
          objeto2.produto_ppise = "0";
          objeto2.produto_pbc_pise = "0";
          objeto2.produto_ppisste = "0";
          objeto2.produto_pBC_pisste = "0";
          objeto2.produto_pcofinse = "0";
          objeto2.produto_pbc_cofinse = "0";
          objeto2.produto_pcofinsste = "0";
          objeto2.produto_pbc_cofinsste = "0";
          objeto2.produto_class_sped = 4;
          objeto2.produto_pesoliq = "0.100";
          objeto2.produto_pesobruto = "0.100";
          objeto2.produto_fatexport = "1.00";
          objeto2.produto_cod_int = "0001";
          objeto2.produto_cta = "123";
          objeto2.produto_intdominio = "000001";
          objeto2.produto_cod = "1234";
          this.prods_post.push({ ...objeto2 });
        }

        // if(objeto2 != undefined){
        //   objeto2.produto_sit = 0
        //   objeto2.produto_nome = item.xProd;
        //   console.log("Monstrnaod Obejto 2")
        //   console.log(objeto2)
        //   this.prods_post.push({ ...objeto2});
        // }

        vet_final.push({ ...objeto });
      });

      console.log("Mostrnado Listagem de Produtos");
      console.log(this.vet_produtos);
      console.log(vet_final);
    },
    // pega os vetor de produtos do xml e adicona a um novo vetor para fazer o post
    vetor_produtos(vet_xml_prods) {
      let vet_prods_xml = [...vet_xml_prods];
      // nao precisa mais chamar essa função
      this.verifica_produto_xml(vet_prods_xml);
      let produto = {};
      let vet_prods_post = [];
      vet_prods_xml.forEach((item) => {
        //
        let res = this.vet_produtos.find((p) => p.codbarras == item.cProd);
        if (res == undefined) {
          produto.codbarras = item.cProd;
          produto.produto_nome = item.xProd;
          produto.produto_descricao = item.xProd;
          produto.idtipo = 1;
          produto.produto_local_estoque_id = 1;
          produto.produto_m_s = "M";
          produto.produto_ncm = item.NCM;
          produto.produto_cest = "12345";
          produto.preco_custo = item.vProd;
          produto.preco = item.vProd;
          produto.produto_margemlucro = "40.00";
          produto.preco_atacado = "1.30";
          produto.unidade_id = 5;
          produto.um = "UNIDADE";
          produto.qtd = item.qCom; // Gerar estoque no local padrão
          produto.ativo = -1;
          produto.produto_controla_estoque = -1;
          produto.produto_balanca = 0;
          produto.produto_produzido = 0;
          produto.grupo_id = 1;
          produto.produto_cean = item.cEANTrib;
          produto.produto_orig = item.imposto.icms.orig;
          produto.produto_cst = item.imposto.icms.CSOSN;
          produto.produto_cstpis = item.imposto.PIS.CST;
          produto.produto_cstcofins = item.imposto.COFINS.CST;
          produto.produto_cstipi = item.imposto.IPI.CST;
          produto.produto_picms = "18";
          produto.produto_pbc_icms = "100";
          produto.produto_cfop = item.CFOP;
          produto.produto_picmsst = "0";
          produto.produto_pbc_icmsst = "0";
          produto.produto_cenq = "999";
          produto.produto_pbc_ipi = "0";
          produto.produto_pipi = "0";
          produto.produto_pbc_pis = "0";
          produto.produto_ppis = "0";
          produto.produto_pbc_cofins = "0";
          produto.produto_pcofins = "0";
          produto.produto_ppisst = "0";
          produto.produto_pBC_pisst = "0";
          produto.produto_pbc_cofinsst = "0";
          produto.produto_pcofinsst = "0";
          produto.produto_cste = null;
          produto.produto_picmse = "0";
          produto.produto_pbc_icmse = "0";
          produto.produto_picmsste = "0";
          produto.produto_pbc_icmsste = "0";
          produto.produto_cenqe = null;
          produto.produto_pipie = "0";
          produto.produto_pbc_ipie = "0";
          produto.produto_ppise = "0";
          produto.produto_pbc_pise = "0";
          produto.produto_ppisste = "0";
          produto.produto_pBC_pisste = "0";
          produto.produto_pcofinse = "0";
          produto.produto_pbc_cofinse = "0";
          produto.produto_pcofinsste = "0";
          produto.produto_pbc_cofinsste = "0";
          produto.produto_class_sped = 4;
          produto.produto_pesoliq = "0.100";
          produto.produto_pesobruto = "0.100";
          produto.produto_fatexport = "1.00";
          produto.produto_cod_int = "0001";
          produto.produto_cta = "123";
          produto.produto_intdominio = "000001";
          produto.produto_cod = "1234";
          // this.doPost({ ...produto });
          vet_prods_post.push({ ...produto });
        } else {
          // remover daqui depois
          vet_prods_post.push({ ...produto });

          console.log("Mostrabdi Objeto Produto");
          res.loc_estoque = this.select_local_estoque_id;
          console.log(res);
          console.log(item);
          this.makeToast(
            "success",
            "Produto : " +
              res.produto_nome +
              " já Cadastrado no Sistema Geradno Estoque"
          );
          // this.doPostAddEstoqueMT(res);
        }
      });

      // this.prods_post = [...vet_prods_post];
      console.log("monstrando Vetor Final de Produtos para cadastros");
      console.log(this.prods_post[0]);
    },
    async doPostAddEstoqueMT(produto) {
      console.log(produto);
      // this.onLoader();
      // this.changeValues(produto, ",", ".");

      console.log("dentro do update");

      try {
        let response = await http.post(
          "/produto/addEstoquemt?empresa_id=" + produto.empresa_id,
          produto
        );
        //console.log(response);

        if (response.status === 200) {
          console.log("entrou aqui");
          // this.getData();
          //this.back();
          // setTimeout(() => {
          //   this.offLoader();
          // }, 1000);
          this.makeToast("success", "Adcionado ao Estoque");
        }
      } catch (error) {
        this.makeToast("danger", error.response);
      }
    },
    makeToast(variant = null, message = "Erro genérico") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    async doPost(produto) {
      // var numsStr = produto.produto_margemlucro.replace(/[^0-9]/g, "");
      // produto.produto_margemlucro = parseInt(numsStr);
      // this.changeValues(produto, ",", ".");
      console.log("mostrando produto no post Crrentt");
      console.log(this.currentProduto);

      try {
        let response = await http
          .post("/produto?empresa_id=" + 1, produto)
          .catch((error) => {
            this.error(error.response);
            this.makeToast("danger", error.response);
          });

        if (response.status === 200) {
          this.makeToast("success", "Registro incluído");
        }
      } catch (error) {
        this.makeToast("danger", error.response);
      }
    },
    changeValues(produto, oldStr, newStr) {
      // var preco;

      // if (!isNaN(parseFloat(produto.preco))) {
      //   preco = produto.preco.toString().replace(oldStr, newStr);
      // } else {
      //   preco = produto.preco.replace(oldStr, newStr);
      // }

      // this.currentProduto.preco = preco;
      var atacado = produto.preco_atacado.toString().replace(oldStr, newStr);
      this.currentProduto.preco_atacado = atacado;
      var custo = produto.preco_custo.toString().replace(oldStr, newStr);
      this.currentProduto.preco_custo = custo;
      var fatexport = produto.produto_fatexport
        .toString()
        .replace(oldStr, newStr);
      this.currentProduto.produto_fatexport = fatexport;
      var margemlucro = produto.produto_margemlucro
        .toString()
        .replace(oldStr, newStr);
      this.currentProduto.produto_margemlucro = margemlucro;
      var qtd = produto.qtd
        ? produto.qtd.toString().replace(oldStr, newStr)
        : "1,00";
      this.currentProduto.qtd = qtd;
      var pesoliq = produto.produto_pesoliq.toString().replace(oldStr, newStr);
      this.currentProduto.produto_pesoliq = pesoliq;
      var pesobruto = produto.produto_pesobruto
        .toString()
        .replace(oldStr, newStr);
      this.currentProduto.produto_pesobruto = pesobruto;
    },
    seleciona_check(objeto, status, index) {
      console.log("Checkbox selector Selecionado Os Arquivos");
      console.log(objeto);
      console.log(status);
      console.log(index);
      let file = objeto;

      if (status === true) {
        this.readFileContent(file)
          .then((content) => {
            this.fileContent = content;
            objeto.conteudo = content;
            objeto.id = index;
            this.guarda_xmls.push(content);
            //   this.ler_xml();
            this.vetor_new_pre_nfe.push({ ...objeto });
          })
          .catch((error) => {
            console.error("Erro ao ler o conteúdo do arquivo:", error);
          });
      } else if (status !== true) {
        // this.vetor_new_pre_nfe.splice(index,1)
        this.vetor_new_pre_nfe = this.vetor_new_pre_nfe.filter(
          (item) => item.id !== index
        );
      }

      // this.$emit("selecinando_xml_nfe",objeto)
      console.log(this.vetor_new_pre_nfe);
    },
    importa_pedido_xml() {
      this.files_array = [];
      this.upload_bool = true;
      this.boll_arquivos = false;
      document.getElementById("fileInput").click();
    },
    seleciona_xml_fora_bd(objeto, status, index) {
      console.log("estou no selecionda fora do BD");
      //console.log(objeto)
      // console.log(status)
      // console.log(index)
      // if()
      //  // this.files_array = []
      //  if(objeto.file instanceof File){
      //    console.log("tem o obejto")
      //  }

      //  let file= new File(["conteúdo"], `${objeto.name}`, {
      //     type: `${objeto.type}`,
      //     size:`${objeto.size}`
      // })
      // console.log(file)
      console.log(index);
      console.log("mostrando o array sme o check33");
      console.log(this.array_files_sem_check);
      delete objeto.check;
      if (status == true) {
        this.files_array2.push({ id: index });
      } else {
        this.files_array2.splice(index, 1);
      }
      console.log(this.files_array2);
    },
    handleFileChange(event) {
      // não era aqui para fazer esse logica é na função de enviar
      const files = Array.from(event.target.files);
      this.array_files_sem_check = [...files];
      this.files_array = [...files];
      console.log("estou no hanfle mostrando os files");
      console.log(this.files_array);
      console.log(this.files_array[0].textContent);

      //   files.forEach((file) => {
      //     // Verifica se o arquivo é um XML
      //     if (file.type === "text/xml" || file.name.endsWith(".xml")) {
      //       this.readFileContent(file)
      //         .then((content) => {
      //           this.fileContent = content;
      //           this.ler_xml();
      //         })
      //         .catch((error) => {
      //           console.error("Erro ao ler o conteúdo do arquivo:", error);
      //         });
      //     } else {
      //       console.warn("O arquivo não é um XML:", file.name);
      //     }
      //   });
      const promises = files.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (e) => reject(e);
          reader.readAsText(file);
        });
      });

      Promise.all(promises)
        .then((contents) => {
          this.xmlContents = contents; // Preenche o array reativo com todos os conteúdos
          console.log("Todos os conteúdos lidos:", this.xmlContents);
          //   this.ver();
        })
        .catch((error) => {
          console.error("Erro ao ler arquivos:", error);
        });

      // const formData = new FormData();
      // this.files_array.forEach(file => {
      //   formData.append('files[]', file);
      // });

      // if (file) {
      //   this.readFileContent(file)
      //     .then((content) => {
      //       this.fileContent = content;
      //       this.ler_xml();
      //     })
      //     .catch((error) => {
      //       console.error("Erro ao ler o conteúdo do arquivo:", error);
      //     });
      // }
      //   this.ver();
    },
    ver() {
      console.log("mosntrnado Conteudos Xmls");
      console.log(this.xmlContents);
      console.log(this.guarda_xmls);
      console.log("nfe Conteudo");
      console.log(this.vetor_new_pre_nfe);
      this.show_modal_produtos = true;
      console.log("nfe prods Produzidos");
      console.log(this.prods_post);
    },
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          resolve(e.target.result);
        };

        reader.onerror = (e) => {
          reject(e.target.error);
        };

        reader.readAsText(file);
      });
    },
    ler_xml() {
      console.log("estou em ler xml ");
      //   console.log(this.fileContent);
      //   this.xmlContents.push(this.fileContent);
      if (typeof this.fileContent === "string") {
        console.log("é uma srting");
      }
      // xml em string //
      let string_xml = this.fileContent;
      // varivel que vai receber o conteudo convertido de string para xml
      let xmlDocument = new DOMParser().parseFromString(string_xml, "text/xml");
      console.log(xmlDocument);
      let nomes = xmlDocument.querySelectorAll("xProd");
      let listaNomes = [];

      nomes.forEach((nome) => {
        listaNomes.push(nome.textContent);
      });
      console.log(listaNomes);
    },
  },
};
</script>

<style>
</style>